var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavigationMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(-29 -28.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    d: "M29,50.675a22,22,0,1,1,0,.1",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    d: "M30,50.677a21,21,0,1,1,0,.1",
    fill: "none",
    stroke: "#7c70ae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.909
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_11",
    d: "M37,50.675a14,14,0,1,1,0,.1",
    fill: "#7c6eb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_12",
    d: "M37.5,50.677a13.5,13.5,0,1,1,0,.1",
    fill: "rgba(0,0,0,0)",
    stroke: "#7c70ae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.964
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_59",
    d: "M56,54.725H46",
    fill: "rgba(0,0,0,0)",
    stroke: "#080808",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_58",
    d: "M56,50.725H46",
    fill: "rgba(0,0,0,0)",
    stroke: "#080808",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_57",
    d: "M56,46.725H46",
    fill: "rgba(0,0,0,0)",
    stroke: "#080808",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationMenuIcon);
export default __webpack_public_path__ + "static/media/navigation_menu_icon.504fbec2ce141c89d48db17be9f5d375.svg";
export { ForwardRef as ReactComponent };